/*! Slight Edition – product card color shuffle v3 (per-card start colour + phase offset + no matching neighbours)
 * Cycles each product card's image through that product's color variants.
 * Self-contained: works on top of Horizon's <product-card> markup without editing core snippets.
 */
(function () {
  'use strict';
  if (window.__seColorShuffle) return;
  window.__seColorShuffle = true;

  var CFG = Object.assign(
    { interval: 3750, jitter: 250, stagger: 650, fade: 700, resumeAfterTouch: 4000, widths: [240, 352, 480, 640, 832, 1200] },
    window.SE_COLOR_SHUFFLE_CONFIG || {}
  );

  var rm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
  if (rm && rm.matches) return; // respect reduced motion: no cycling at all

  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var DATA = {};
  try {
    var el = document.getElementById('se-color-shuffle-data');
    if (el) DATA = JSON.parse(el.textContent || '{}') || {};
  } catch (e) { DATA = {}; }

  var cards = [];
  var STATS = { changes: 0, holds: 0, forced: 0 };
  var seq = 0;
  // Phase step between card i and card i+1 (fraction of one cycle). 3/7 keeps every card within
  // 6 places (row, column and diagonal neighbours at 2-5 across) at least 1/7 of a cycle apart.
  var STEP = 3 / 7;
  var T0 = Date.now();     // shared clock so every card keeps its own fixed phase

  // Words of a string, lowercased, padded: "Tee in Chalky Mint" -> " tee in chalky mint "
  function words(s) { return ' ' + String(s || '').toLowerCase().replace(/%20/g, ' ').replace(/[^a-z0-9]+/g, ' ').trim() + ' '; }
  // Which color is the card's own image? Match by URL, then the image alt, then the file name.
  // Longest color name wins so "Light Pink" beats "Pink" and "True Navy" beats "Navy".
  function startIndex(colors, img) {
    var cur = stripQuery(img.currentSrc || img.getAttribute('src'));
    for (var i = 0; i < colors.length; i++) if (stripQuery(colors[i].u) === cur) return i;
    var file = cur.split('/').pop().replace(/\.[a-z0-9]+$/i, '').replace(/_[0-9a-f]{8}-[0-9a-f-]{27,}$/i, '');
    var hay = [words(img.getAttribute('alt')), words(file)];
    for (var h = 0; h < hay.length; h++) {
      var best = -1, bestLen = 0;
      colors.forEach(function (c, i) {
        var w = words(c.c);
        if (w.length > 2 && hay[h].indexOf(w) > -1 && w.length > bestLen) { best = i; bestLen = w.length; }
      });
      if (best > -1) return best;
    }
    return 0;
  }

  function stripQuery(u) { return String(u || '').split('?')[0].replace(/^https?:/, ''); }
  function withWidth(u, w) { return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
  function srcsetFor(u) { return CFG.widths.map(function (w) { return withWidth(u, w) + ' ' + w + 'w'; }).join(', '); }
  function handleFromHref(href) {
    var m = /\/products\/([^/?#]+)/.exec(href || '');
    return m ? decodeURIComponent(m[1]) : null;
  }

  // Normalize to [{c, v, u}] – one per color, deduped by color and by image.
  function normalize(list) {
    var seenC = {}, seenU = {}, out = [];
    (list || []).forEach(function (e) {
      if (!e || !e.u) return;
      var ck = String(e.c || '').toLowerCase(), uk = stripQuery(e.u);
      if (seenC[ck] || seenU[uk]) return;
      seenC[ck] = seenU[uk] = 1;
      out.push({ c: e.c, v: e.v, u: e.u });
    });
    return out;
  }

  // Fallback when the page has no Liquid data for this handle: /products/<handle>.js
  var fetchCache = {};
  function fetchColors(handle) {
    if (fetchCache[handle]) return fetchCache[handle];
    fetchCache[handle] = fetch(ROOT + 'products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        if (!p) return [];
        var idx = -1;
        (p.options || []).forEach(function (o, i) {
          var n = String(o.name || o).toLowerCase();
          if (n === 'color' || n === 'colour') idx = i;
        });
        if (idx < 0) return [];
        var key = 'option' + (idx + 1);
        var byColor = {}, order = [];
        (p.variants || []).forEach(function (v) {
          var c = v[key];
          if (!byColor[c]) { byColor[c] = []; order.push(c); }
          byColor[c].push(v);
        });
        var media = p.media || [];
        return order.map(function (c) {
          var vs = byColor[c];
          var pick = vs.filter(function (v) { return v.available; })[0] || vs[0];
          var withImg = vs.filter(function (v) { return v.featured_image; })[0];
          var u = withImg && withImg.featured_image.src;
          if (!u) {
            var lc = String(c).toLowerCase();
            var m = media.filter(function (m) { return m.alt && String(m.alt).toLowerCase().indexOf(lc) > -1; })[0];
            u = m && (m.src || (m.preview_image && m.preview_image.src));
          }
          return { c: c, v: pick && pick.id, u: u };
        });
      })
      .catch(function () { return []; });
    return fetchCache[handle];
  }

  function getColors(handle) {
    if (DATA[handle]) return Promise.resolve(DATA[handle]);
    return fetchColors(handle);
  }

  function setVariantHref(card, variantId) {
    if (!variantId) return;
    card.links.forEach(function (a) {
      var base = a.getAttribute('data-se-base-href');
      if (base == null) { base = a.getAttribute('href') || ''; a.setAttribute('data-se-base-href', base); }
      var clean = base.replace(/([?&])variant=\d+(&|$)/, '$1').replace(/[?&]$/, '');
      a.setAttribute('href', clean + (clean.indexOf('?') > -1 ? '&' : '?') + 'variant=' + variantId);
    });
  }

  function setup(cardEl) {
    if (cardEl.__seCS) return;
    cardEl.__seCS = true;
    var order = seq++; // DOM order, taken before any async work so neighbours get neighbouring indexes
    var link = cardEl.querySelector('a.product-card__link, a[ref="productCardLink"], a[href*="/products/"]');
    var handle = link && handleFromHref(link.getAttribute('href'));
    if (!handle) return;
    var gallery = cardEl.querySelector('[ref="cardGallery"], .card-gallery');
    if (!gallery) return;

    getColors(handle).then(function (raw) {
      var colors = normalize(raw);
      if (colors.length < 2) return; // single color: stay static

      var firstImg = gallery.querySelector('slideshow-slide:not([hidden]) img, img');
      if (!firstImg) return;
      var host = firstImg.closest('.product-media') || firstImg.parentElement;

      // Start with the color the card already shows (its featured image) and rotate the
      // color order so the cycle continues from there: [start, start+1, ..., 0, ..., start-1].
      var start = startIndex(colors, firstImg);
      colors = colors.slice(start).concat(colors.slice(0, start));
      start = 0;

      var sizes = (firstImg.getAttribute('sizes') || '100vw').replace(/^\s*auto\s*,\s*/, '');
      var fit = getComputedStyle(firstImg).objectFit || 'cover';

      var layer = document.createElement('div');
      layer.className = 'se-cs-layer';
      layer.setAttribute('aria-hidden', 'true');
      var a = document.createElement('img'), b = document.createElement('img');
      [a, b].forEach(function (im) {
        im.className = 'se-cs-img';
        im.alt = '';
        im.decoding = 'async';
        im.loading = 'lazy';
        im.sizes = sizes;
        im.style.objectFit = fit;
        layer.appendChild(im);
      });
      if (getComputedStyle(host).position === 'static') host.style.position = 'relative';
      host.appendChild(layer);

      var links = Array.prototype.slice.call(cardEl.querySelectorAll('a[href*="/products/"]'))
        .filter(function (x) { return handleFromHref(x.getAttribute('href')) === handle; });

      var card = {
        el: cardEl, handle: handle, colors: colors, idx: start, layer: layer, front: a, back: b,
        links: links, sizes: sizes, timer: null, visible: false, hover: false, touchUntil: 0, dead: false,
        // Fixed phase within the shared cycle: index * STEP + a small random jitter.
        phase: ((order * STEP + (Math.random() * 2 - 1) * 0.025) % 1 + 1) % 1,
        first: true
      };
      cards.push(card);
      setVariantHref(card, colors[start].v);
      cardEl.setAttribute('data-se-color', colors[start].c);
      cardEl.setAttribute('data-se-shown', colors[start].c);

      // Pause on hover (mouse) and touch.
      cardEl.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') { card.hover = true; } });
      cardEl.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse') { card.hover = false; schedule(card); } });
      cardEl.addEventListener('touchstart', function () { card.touchUntil = Date.now() + CFG.resumeAfterTouch; }, { passive: true });

      // If the shopper picks a swatch on the card, hand control back to the theme.
      cardEl.addEventListener('change', function (e) {
        if (e.target && e.target.closest && e.target.closest('swatches-variant-picker-component, variant-picker, .variant-option, [ref="swatches"]')) destroy(card);
      });

      io && io.observe(cardEl);
      if (!io) { card.visible = true; schedule(card); }
    });
  }

  // ---- Neighbour-aware colour choice -------------------------------------------------------
  // Compare colour FAMILIES, not names: "Navy" and "True Navy", "Ivory" and "White", "Ash" and
  // "Sport Grey" look the same on a card, so they count as a match.
  var FAMILIES = [
    ['navy', /navy/], ['black', /black|charcoal/], ['pink', /pink|blossom|rose|berry|peach|coral/],
    ['green', /mint|sage|green|olive|moss/], ['blue', /blue|chambray|denim|aqua|teal/],
    ['white', /white|ivory|cream|natural|bone/], ['grey', /gr[ae]y|ash|heather$/],
    ['yellow', /butter|yellow|gold|mustard/], ['sand', /sand|khaki|tan|beige|oat|camel/]
  ].concat(window.SE_COLOR_FAMILIES || []);
  var famCache = {};
  function ck(c) {
    if (!c) return '';
    var name = String(c.c || '').toLowerCase().trim();
    if (famCache[name] == null) {
      famCache[name] = name;
      for (var i = 0; i < FAMILIES.length; i++) if (FAMILIES[i][1].test(name)) { famCache[name] = FAMILIES[i][0]; break; }
    }
    return famCache[name];
  }
  // Cards that touch this one in the grid as it is rendered right now (left, right, above, below,
  // diagonals). Uses live layout, so it follows any column count and window resize.
  function neighbours(card) {
    var r = card.el.getBoundingClientRect();
    if (!r.width || !r.height) return [];
    var cx = r.left + r.width / 2, cy = r.top + r.height / 2;
    return cards.filter(function (o) {
      if (o === card || o.dead) return false;
      var q = o.el.getBoundingClientRect();
      if (!q.width || !q.height) return false;
      var dx = Math.abs(q.left + q.width / 2 - cx), dy = Math.abs(q.top + q.height / 2 - cy);
      return (dx > 1 || dy > 1) && dx < r.width * 1.5 && dy < r.height * 1.5;
    });
  }
  // Next colour in this card's rotation that no neighbour shows now (or is fading to/from), preferring
  // one no neighbour plans to change to next. If every option clashes: hold the current colour for
  // this beat when it is itself clash-free, otherwise take the least-used option.
  function chooseNext(card) {
    var n = card.colors.length, mine = ck(card.colors[card.idx]);
    if (n < 2) return card.idx;
    var now = {}, soon = {};
    neighbours(card).forEach(function (o) {
      var a = ck(o.colors[o.idx]); now[a] = (now[a] || 0) + 1;
      if (o.pending) { var p = ck(o.pending); now[p] = (now[p] || 0) + 1; }
      if (o.leaving) { var l = ck(o.leaving); now[l] = (now[l] || 0) + 1; } // still fading out
      if (o.plan) { var q = ck(o.plan); soon[q] = (soon[q] || 0) + 1; }
    });
    var best = -1, bestScore = Infinity;
    for (var k = 1; k < n; k++) {
      var i = (card.idx + k) % n, key = ck(card.colors[i]);
      if (key === mine) continue;
      var score = (now[key] || 0) * 100 + (soon[key] || 0);
      if (score === 0) { card.lastScore = 0; return i; }
      if (score < bestScore) { best = i; bestScore = score; }
    }
    card.lastScore = bestScore;
    if (best > -1 && bestScore >= 100 && !now[mine]) return card.idx; // hold: changing would create a match
    return best > -1 ? best : (card.idx + 1) % n;
  }

  function destroy(card) {
    card.dead = true;
    clearTimeout(card.timer);
    card.layer.remove();
  }

  function paused(card) {
    return card.dead || card.hover || !card.visible || document.hidden || Date.now() < card.touchUntil;
  }

  // Load ONLY the next color's image into the hidden layer, at the card's own sizes.
  function loadInto(im, c, sizes) {
    if (im.__u === c.u && im.complete && im.naturalWidth) return Promise.resolve();
    im.__u = c.u;
    im.loading = 'eager';
    im.sizes = sizes;
    im.srcset = srcsetFor(c.u);
    im.src = withWidth(c.u, 640);
    return (im.decode ? im.decode() : new Promise(function (r) { im.onload = im.onerror = r; })).catch(function () {});
  }

  function step(card) {
    card.timer = null;
    if (paused(card)) { schedule(card); return; }
    if (card.finish) card.finish(); // previous fade still pending: settle it first
    var next = chooseNext(card);
    if (next === card.idx) { STATS.holds++; card.plan = null; schedule(card); return; } // hold this beat
    STATS.changes++; if (card.lastScore >= 100) STATS.forced++;
    card.pending = card.colors[next]; // neighbours treat this as shown from now on
    card.plan = null;
    var incoming = card.back, outgoing = card.front;
    loadInto(incoming, card.colors[next], card.sizes).then(function () {
      card.pending = null;
      if (card.dead) return;
      if (paused(card)) { schedule(card); return; }
      // Incoming fades in on top; outgoing stays opaque underneath until the fade is done.
      outgoing.classList.remove('is-top');
      incoming.classList.add('is-top');
      void incoming.offsetWidth;
      incoming.classList.add('is-on');
      card.front = incoming; card.back = outgoing;
      card.leaving = card.colors[card.idx]; // still visible underneath until the fade really ends
      card.idx = next;
      // Finish when the fade has actually ended (transitionend; timer only as a fallback, since a busy
      // page can run the CSS fade late). Then drop the old image, and only then pick the likely next
      // colour (re-checked when the change is due) and preload just that image into the hidden layer.
      var done = false;
      function finish() {
        if (done) return;
        done = true;
        card.finish = null;
        incoming.removeEventListener('transitionend', onEnd);
        if (card.front !== outgoing) outgoing.classList.remove('is-on');
        card.leaving = null;
        if (card.dead || card.front !== incoming) return;
        card.el.setAttribute('data-se-shown', card.colors[card.idx].c);
        var pi = chooseNext(card);
        card.plan = pi === card.idx ? null : card.colors[pi];
        if (card.plan) loadInto(outgoing, card.plan, card.sizes);
      }
      function onEnd(e) { if (e.target === incoming && e.propertyName === 'opacity') finish(); }
      incoming.addEventListener('transitionend', onEnd);
      card.finish = finish;
      setTimeout(finish, CFG.fade + 1500);
      setVariantHref(card, card.colors[next].v);
      card.el.setAttribute('data-se-color', card.colors[next].c);
      schedule(card);
    });
  }

  // Next change = the next moment this card's phase comes round on the shared clock, so
  // neighbouring cards (different phases) never change together and never drift into step.
  function schedule(card) {
    if (card.timer || card.dead) return;
    var now = Date.now(), I = CFG.interval;
    var earliest = now + (card.first ? I * 0.5 : I * 0.35);
    if (now < card.touchUntil) earliest = Math.max(earliest, card.touchUntil + 200);
    var k = Math.ceil((earliest - T0) / I - card.phase);
    var at = T0 + (k + card.phase) * I + (Math.random() * 2 - 1) * Math.min(CFG.jitter, 60);
    if (card.first && card.visible) { // warm the first change
      var fi = chooseNext(card);
      card.plan = fi === card.idx ? null : card.colors[fi];
      if (card.plan) loadInto(card.back, card.plan, card.sizes);
    }
    card.first = false;
    card.timer = setTimeout(function () { step(card); }, Math.max(0, at - now));
  }

  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      var card = cards.filter(function (c) { return c.el === en.target; })[0];
      if (!card) return;
      card.visible = en.isIntersecting;
      if (card.visible) schedule(card);
    });
  }, { rootMargin: '100px 0px' }) : null;

  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) cards.forEach(schedule);
  });
  if (rm && rm.addEventListener) rm.addEventListener('change', function (e) { if (e.matches) cards.forEach(destroy); });

  var SEL = 'product-card, .product-card';
  function scan(root) {
    (root.querySelectorAll ? root.querySelectorAll(SEL) : []).forEach(setup);
  }
  function init() {
    scan(document);
    new MutationObserver(function (muts) {
      muts.forEach(function (m) {
        m.addedNodes.forEach(function (n) {
          if (n.nodeType !== 1) return;
          if (n.matches && n.matches(SEL)) setup(n); else scan(n);
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();

  window.SEColorShuffle = { cards: cards, config: CFG, stats: STATS };
})();
